import { Component } from '@angular/core';
import { FooterComponent } from './footer.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.container.component.html',
  styleUrl: './footer.container.component.scss',
  standalone: true,
  imports: [FooterComponent],
})
export class FooterContainerComponent {}
